// Release slot for this tab (CPRD-5918); see infrastructure/stacks/auxo-web/readme.md.

// Routing hint only, not HttpOnly; authorization stays at the API.
export const RELEASE_COOKIE = 'auxo_release';
export const RELEASE_EXIT_PATH = '/_release/exit';
export const PREVIEW_API_SEGMENT = '/preview';

export function readReleaseCookie(cookieString) {
  for (const part of String(cookieString ?? '').split(';')) {
    const eq = part.indexOf('=');
    if (eq === -1 || part.slice(0, eq).trim() !== RELEASE_COOKIE) continue;
    const value = part.slice(eq + 1).trim();
    try {
      return decodeURIComponent(value);
    } catch {
      return value;
    }
  }
  return '';
}

export function buildVersion() {
  return String(import.meta.env.VITE_APP_VERSION ?? '').trim();
}

// Preview only when the cookie names this build: the edge serves live to any other tag.
export function slot() {
  const tag = readReleaseCookie(
    typeof document === 'undefined' ? '' : document.cookie
  );
  const version = buildVersion();
  return tag && version && tag === version ? 'preview' : 'live';
}

export function releaseTag() {
  return slot() === 'preview' ? buildVersion() : '';
}

export function apiBase() {
  const endpoint = String(
    import.meta.env.VITE_INSURANCE_API_GATEWAY_ENDPOINT ?? ''
  );
  if (!endpoint || slot() !== 'preview') return endpoint;
  return `${endpoint.replace(/\/+$/, '')}${PREVIEW_API_SEGMENT}`;
}

// Rebases gateway URLs onto apiBase(); anything else is returned untouched.
export function inSlot(url) {
  const endpoint = String(
    import.meta.env.VITE_INSURANCE_API_GATEWAY_ENDPOINT ?? ''
  ).replace(/\/+$/, '');
  if (!url || !endpoint || slot() !== 'preview') return url;
  if (url !== endpoint && !url.startsWith(`${endpoint}/`)) return url;
  return `${apiBase()}${url.slice(endpoint.length)}`;
}
